import type { AdminListTransferTicketsParams } from '../api'
import { ETransferQueryKey } from './admin-transfer.types'
import adminTransferService from './admin-transfer.service'

export const adminListTransferTicketsOptions = (
  params: AdminListTransferTicketsParams,
) => ({
  queryKey: [ETransferQueryKey.ADMIN_LIST_TRANSFER_TICKETS, params],
  queryFn: () => adminTransferService.adminListTransferTickets(params),
})
